import React from 'react';
import './index.module.scss';

export interface ButtonIPros {
  children?: string | React.ReactNode, // 按钮文案
  disabled?: boolean; // 按钮是否禁用
  type?:  'default' | 'primary'; // 按钮类型 default primary warn
  size?: 'default' | 'large' | 'small'; // 按钮尺寸  default-32px large-40px small-24px
  onClick?: (...args: any[]) => void;
  className?: string;
}

const Button = (props: ButtonIPros): React.ReactElement => {
  const {
    children = '',
    type = 'default',
    size = 'default',
    disabled = false,
    className = '',
    ...rest
  } = props;

  return (
    <button className={`common-button type-${type} size-${size} ${disabled ? 'disabled' : ''} ${className}`} {...rest}>{children || ''}</button>
  )
}

export default Button;